<template>
     <div>
       <div v-show="newList" class="card page mb-5 p-2" style="width:1300px;margin:0 auto;box-shadow: 10px 10px 5px #888888;" id="v-content" :style="{minHeight:Height+'px'}">
             <p>
                  <span class="float-right span_close" style="display:block;width:20px;line-height:20px;text-align:center;font-size:25px;" @click="$router.go(-1)">
                           &times;
                  </span>
             </p>
            <div>
                  <div>
                  <div>
                      <p style="font-size:20px;text-align:center;" class="mt-2">{{newList.title}}
                      </p>
                      <div v-html="content" class="mt-3 text-center">
                          {{content}}
                      </div>
                      <p style="float:right;">
                        <span>
                           作者:
                        </span>
                         {{newList.author}}
                      </p>
                  </div>
                  </div>
            </div>
       </div>
     <div>
      <transition name="fade">
        <loading v-if="isLoading"></loading>
      </transition>
    </div>
  </div>
</template>
<script>
import Loading from '../components/Loading.vue'
import { mapState } from 'vuex';
export default {
  name:'news',
  data(){
    return {
           Height:0,
           id:'',
           isLoading:false,
           content:'',
    }
  },
  computed:{
     ...mapState([
       'newList'
     ])
  },
   components:{
        Loading
    },
    methods:{
      //处理现实图片
      getImage(){
          this.content=this.newList.content.replace(/@/g, "http://www.hyey.com/")
      },
    getList: async function () {
        // this.isLoading=true;
    const {data: res} = await this.$http.get("http://192.168.1.215:8088/Home/getMenuList",{
         
        })
        // console.log(res)
         let that=this;
         that.news=res.mesg;
        //  that.isLoading=false;
      },
      getID(){
         this.id=this.$route.query.id;
      }
    },
     mounted(){
          //动态设置内容高度 让footer始终居底   header+footer的高度是100
    this.Height = document.documentElement.clientHeight - 100;  
　　//监听浏览器窗口变化　
    window.onresize = ()=> {this.Height = document.documentElement.clientHeight -100}
  
    },
    created(){
      //  this.getID()
      //    this.getList()
      this.getImage();
    }
}   
</script>
<style scoped>
  .page{
    box-sizing: border-box;
    min-height: 100%;
    padding-bottom: 50px;
  }
  .span_close:hover{
       color:#3190e8;
 }
 
</style>



// WEBPACK FOOTER //
// src/pages/newsList.vue